import Vue from 'vue'
import axios from 'axios'
import { COMMON } from '@/common'
import { Notify } from 'vant'
import { getToken, setToken, removeToken } from '@/utils/cookie'
import store from '@/store'
import router from '@/router'
import qs from 'qs'

const signAppId = 'uccAdminSign'
const signSecret = 'TAItMmqsSyKkVxXv'

export function getBaseServer () {
  return COMMON.SERVER_URL
}

export function toMedia (url) {
  if (url && url.indexOf('http') > -1) {
    return url
  }
  return COMMON.MEDIA_URL + url
}

function checkParamEmpty (obj) {
  return obj !== undefined &&
    obj !== null &&
    obj.length !== 0 &&
    (obj || obj === 0)
}

const service = axios.create({
  baseURL: COMMON.SERVER_URL,
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 20000
})

service.interceptors.request.use(
  config => {
    // 一般情况下直接再route对象中取conferenceId就行了
    // 但是如果是在router.beforeEach中，判断store中没有userId而调用getInfo方法的话，
    // 此时router.currentRoute还没有完成赋值，只有beforeEach中接收的to对象中能获取到我们需要的参数
    // 所以在这种时候，可以把to中的参数同步到store中，然后此处再在store.getters中获取就行了。
    const route = router.currentRoute
    const conferenceId = route.params.conferenceId ? route.params.conferenceId : store.getters.conferenceId
    const type = route.params.type ? route.params.type : store.getters.type
    config.headers['Content-Type'] = 'application/json'
    const cookieToken = getToken(conferenceId + type)
    if (cookieToken && cookieToken !== '') {
      config.headers.Authorization = COMMON.JWT_TOKEN_BEAR + cookieToken
    }
    if (Object.hasOwnProperty.call(config, 'data') &&
      Object.hasOwnProperty.call(config.data, 'file')) {
      config.timeout = 0
      config.headers['Content-Type'] = 'multipart/form-data'
      const formdata = new FormData()
      formdata.set('file', config.data.file)
      config.data = formdata
    }

    // 添加签名头信息
    const timestamp = (new Date().getTime()).toString()
    const obj = { appid: signAppId, timestamp: timestamp }
    // 添加语言标识
    if (Vue) {
      obj.language = Vue.prototype.$locale()
      if (config.data) {
        config.data.language = obj.language
      }
      if (config.params) {
        config.params.language = obj.language
      } else {
        config.params = { language: obj.language }
      }
    }

    const fixedObj = Object.assign({}, obj, config.params, config.data)
    // 签名
    const newData = {}
    Object.keys(fixedObj).sort().map(key => {
      if (checkParamEmpty(fixedObj[key])) {
        if (['page', 'limit', 'file', 'order', 'field'].indexOf(key) === -1) {
          newData[key] = fixedObj[key]
        }
      }
      return key
    })
    const sha1 = require('sha1')
    config.headers['brintechapi-appid'] = signAppId
    config.headers['brintechapi-timestamp'] = timestamp
    // console.log(newData);
    config.headers['brintechapi-sign'] = sha1(JSON.stringify(newData) + signSecret)
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    // do something with request error
    console.error(error)
    return Promise.reject(error)
  }
)
// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    const route = router.currentRoute
    const conferenceId = route.params.conferenceId ? route.params.conferenceId : store.getters.conferenceId
    const type = route.params.type ? route.params.type : store.getters.type
    // console.log(route)
    if (response.headers['content-type'] === 'application/msexcel;charset=UTF-8' ||
      response.headers['content-type'].startsWith('application/octet-stream;')) {
      return response
    }
    // if the custom code is not 200, it is judged as an error.
    if (res.code && res.code !== 200) {
      if (handleLoginErr(res)) {
        return
      }
      Notify({
        message: res.message || 'Error',
        type: 'danger',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      if (Object.hasOwnProperty.call(response.headers, 'authorization')) {
        res.token = response.headers.authorization
        setToken(response.headers.authorization, conferenceId + type)
        store.dispatch('user/setUserToken')
      }
      return res
    }
  },
  error => {
    const route = router.currentRoute
    const conferenceId = route.params.conferenceId ? route.params.conferenceId : store.getters.conferenceId
    const type = route.params.type ? route.params.type : store.getters.type
    // console.log(error)
    if (Object.hasOwnProperty.call(error.response.headers, 'authorization')) {
      setToken(error.response.headers.authorization, conferenceId + type)
      store.dispatch('user/setUserToken')
    }
    if (error.response.data) {
      const data = error.response.data
      if (error.response.data.message) {
        error.message = error.response.data.message
      }
      if (handleLoginErr(data)) {
        return
      }
      if (data.message) {
        error.message = error.response.data.message
      }
      Notify({
        message: error.message,
        type: 'danger',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

function handleLoginErr (data) {
  const route = router.currentRoute
  const conferenceId = route.params.conferenceId ? route.params.conferenceId : store.getters.conferenceId
  const type = route.params.type ? route.params.type : store.getters.type
  const logoutCode = [1009, 1402, 1401, 1400]
  if (logoutCode.indexOf(data.code) !== -1 || data.message === '凭证无效或已过期') {
    removeToken(conferenceId + type)
    store.dispatch('user/logout')
    router.push('/' + encodeURIComponent(conferenceId) + '/' + type + '/login')
    Notify({
      message: data.message,
      type: 'danger',
      duration: 5 * 1000
    })
    return true
  }
  return false
}

export default service
